module.exports = __webpack_public_path__ + "static/img/design-1.852b22b2.png";